export default __webpack_public_path__ + "static/media/backArrow.8cba9fe9.svg";